import React from 'react'
import styles from './index.module.css'

export default function Separator() {
  return <div data-testid="separator" className={styles.separator} />
}

Separator.displayName = 'Form.Separator'
